export function stableStringify(value: unknown): string {
  const seen = new WeakSet();
  const stringify = (val: unknown): string => {
    if (val === null || typeof val !== 'object') return JSON.stringify(val);
    if (seen.has(val as object)) return '"[Circular]"';
    seen.add(val as object);
    if (Array.isArray(val)) return `[${val.map((v) => stringify(v)).join(',')}]`;
    const obj = val as Record<string, unknown>;
    const keys = Object.keys(obj).sort();
    const parts = keys.map((k) => `${JSON.stringify(k)}:${stringify(obj[k])}`);
    return `{${parts.join(',')}}`;
  };
  return stringify(value);
}

export function makeCustomersQueryKey(query: Record<string, unknown>): string {
  const keyObj = {
    page: query.page ?? undefined,
    limit: query.limit ?? undefined,
    sortBy: query.sortBy ?? undefined,
    sortOrder: query.sortOrder ?? undefined,
    cursor: query.cursor ?? undefined,
    filters: Object.entries(query)
      .filter(([k]) => !['page', 'limit', 'sortBy', 'sortOrder', 'cursor'].includes(k))
      .reduce<Record<string, unknown>>((acc, [k, v]) => {
        if (v !== undefined) acc[k] = v;
        return acc;
      }, {}),
  };
  return stableStringify(keyObj);
}

export function makeProgressiveTiersQueryKey(query: Record<string, unknown>): string {
  const keyObj = {
    page: query.page ?? undefined,
    limit: query.limit ?? undefined,
    sortBy: query.sortBy ?? undefined,
    sortOrder: query.sortOrder ?? undefined,
    cursor: query.cursor ?? undefined,
    filters: Object.entries(query)
      .filter(([k]) => !['page', 'limit', 'sortBy', 'sortOrder', 'cursor'].includes(k))
      .reduce<Record<string, unknown>>((acc, [k, v]) => {
        if (v !== undefined) acc[k] = v;
        return acc;
      }, {}),
  };
  return stableStringify(keyObj);
}

export function makeAccountsQueryKey(query: Record<string, unknown>): string {
  const keyObj = {
    page: query.page ?? undefined,
    limit: query.limit ?? undefined,
    sortBy: query.sortBy ?? undefined,
    sortOrder: query.sortOrder ?? undefined,
    cursor: query.cursor ?? undefined,
    filters: Object.entries(query)
      .filter(([k]) => !['page', 'limit', 'sortBy', 'sortOrder', 'cursor'].includes(k))
      .reduce<Record<string, unknown>>((acc, [k, v]) => {
        if (v !== undefined) acc[k] = v;
        return acc;
      }, {}),
  };
  return stableStringify(keyObj);
}

export function makeTiersQueryKey(query: Record<string, unknown>): string {
  const keyObj = {
    page: query.page ?? undefined,
    limit: query.limit ?? undefined,
    sortBy: query.sortBy ?? undefined,
    sortOrder: query.sortOrder ?? undefined,
    cursor: query.cursor ?? undefined,
    filters: Object.entries(query)
      .filter(([k]) => !['page', 'limit', 'sortBy', 'sortOrder', 'cursor'].includes(k))
      .reduce<Record<string, unknown>>((acc, [k, v]) => {
        if (v !== undefined) acc[k] = v;
        return acc;
      }, {}),
  };
  return stableStringify(keyObj);
}

export function makeSkusQueryKey(query: Record<string, unknown>): string {
  const keyObj = {
    page: query.page ?? undefined,
    limit: query.limit ?? undefined,
    sortBy: query.sortBy ?? undefined,
    sortOrder: query.sortOrder ?? undefined,
    cursor: query.cursor ?? undefined,
    filters: Object.entries(query)
      .filter(([k]) => !['page', 'limit', 'sortBy', 'sortOrder', 'cursor'].includes(k))
      .reduce<Record<string, unknown>>((acc, [k, v]) => {
        if (v !== undefined) acc[k] = v;
        return acc;
      }, {}),
  };
  return stableStringify(keyObj);
}

export function makeEnvironmentsQueryKey(query: Record<string, unknown>): string {
  const keyObj = {
    page: query.page ?? undefined,
    limit: query.limit ?? undefined,
    sortBy: query.sortBy ?? undefined,
    sortOrder: query.sortOrder ?? undefined,
    cursor: query.cursor ?? undefined,
    filters: Object.entries(query)
      .filter(([k]) => !['page', 'limit', 'sortBy', 'sortOrder', 'cursor'].includes(k))
      .reduce<Record<string, unknown>>((acc, [k, v]) => {
        if (v !== undefined) acc[k] = v;
        return acc;
      }, {}),
  };
  return stableStringify(keyObj);
}

export function makeReportingDatabasesQueryKey(query: Record<string, unknown>): string {
  const keyObj = {
    page: query.page ?? undefined,
    limit: query.limit ?? undefined,
    sortBy: query.sortBy ?? undefined,
    sortOrder: query.sortOrder ?? undefined,
    cursor: query.cursor ?? undefined,
    filters: Object.entries(query)
      .filter(([k]) => !['page', 'limit', 'sortBy', 'sortOrder', 'cursor'].includes(k))
      .reduce<Record<string, unknown>>((acc, [k, v]) => {
        if (v !== undefined) acc[k] = v;
        return acc;
      }, {}),
  };
  return stableStringify(keyObj);
}

export function makeErroredSkusQueryKey(query: Record<string, unknown>): string {
  const keyObj = {
    page: query.page ?? undefined,
    limit: query.limit ?? undefined,
    sortBy: query.sortBy ?? undefined,
    sortOrder: query.sortOrder ?? undefined,
    cursor: query.cursor ?? undefined,
    filters: Object.entries(query)
      .filter(([k]) => !['page', 'limit', 'sortBy', 'sortOrder', 'cursor'].includes(k))
      .reduce<Record<string, unknown>>((acc, [k, v]) => {
        if (v !== undefined) acc[k] = v;
        return acc;
      }, {}),
  };
  return stableStringify(keyObj);
}
